
    import { createSlice, PayloadAction } from '@reduxjs/toolkit'
    
    type TPermissionState =  {
        data: [],
        perPage: number,
        currentPage: number,
        totalPage: number,
        searchTerm: string,
        loading: boolean,
        sortBy: string,
        sortColumn:string,
    }
    
    
    const initialPermissionState: TPermissionState = {
        data: [],
        perPage: 10,
        currentPage: 1,
        totalPage: 1,
        searchTerm: "",
        loading: false,
        sortBy: "desc",
        sortColumn:""
    
        
    }
    
    export const PermissionSlice = createSlice({
        name: 'Permission',
        initialState:initialPermissionState,
        reducers: {
            setPermission: (state:TPermissionState, { payload }: PayloadAction<[]>) => {
              state.data=payload
             },
            setPerPage: (state:TPermissionState, {payload}: PayloadAction<number>) => {
                state.perPage = payload;
            },
            setCurrentPage: (state:TPermissionState, {payload}: PayloadAction<number>) => { 
                state.currentPage = payload;
            },
            setTotalPage: (state:TPermissionState, {payload}: PayloadAction<number>) => { },
            setSearchTerm: (state:TPermissionState, {payload}: PayloadAction<string>) => { 
                state.searchTerm = payload;
            },
            setSortBy: (state:TPermissionState, {payload}: PayloadAction<string>) => { 
              state.sortBy = payload;
          },
          setSortColumn: (state:TPermissionState, {payload}: PayloadAction<string>) => { 
            state.sortColumn = payload;
            state.sortBy = "desc";
        },
            setLoading: (state:TPermissionState, {payload}: PayloadAction<boolean>) => { 
              state.loading = payload
            },
        },
    })
    
    
    export const { setPermission, setPerPage, setCurrentPage, setSortColumn,setSortBy, setTotalPage, setSearchTerm, setLoading } = PermissionSlice.actions
    export default PermissionSlice.reducer
    